<template>
  <transition :name="noTransition ? 'none' : 'textmessage_slide'">
    <slot />
  </transition>
</template>

<script setup lang="ts">
import { usePreferredReducedMotion } from "@vueuse/core";
import { computed } from "vue";
const preferredMotion = usePreferredReducedMotion();
const noTransition = computed(() => {
  return preferredMotion.value === "reduce";
});

const { direction = "left", amount = 200 } = defineProps<{
  direction?: "left" | "right";
  amount?: number;
}>();

const translateXValue = direction === "left" ? `-${amount}px` : `${amount}px`;
</script>

<style>
.textmessage_slide-enter-from {
  transform: translateX(v-bind(translateXValue));
}

.textmessage_slide-enter-active {
  transition: all 0.5s linear;
  transition-delay: 0.1s;
  /* made with https://easingwizard.com/ */
  transition-timing-function: linear(
    0,
    0.345 8.4%,
    0.616 17.2%,
    0.819 26.6%,
    0.894 31.5%,
    0.955 36.7%,
    0.995 41.3%,
    1.024 46.2%,
    1.043 51.4%,
    1.052 57.1%,
    1.049 66%,
    1.008 88.4%,
    1
  );
}

.textmessage_slide-enter-to {
  transform: translateX(0px);
  opacity: 1;
}

/* Do we need the leave transition? */
.textmessage_slide-leave {
  transform: translateX(0px);
}

.textmessage_slide-leave-active {
  transition: transform 0.5s;
}

.textmessage_slide-leave-to {
  transform: translateX(-100px);
}
</style>
